import {
  createAccount,
  createAccountSuccess,
  getEmailToVerify,
  getEmailToVerifySuccess,
  getUsers,
  getUsersFailure,
  getUsersSuccess,
  inviteUsers,
  inviteUsersFailure,
  inviteUsersSuccess,
  resetPassword,
  resetPasswordSuccess,
  saveUser,
  saveUserFailure,
  saveUserSuccess,
  verifyEmail,
  verifyEmailFailure,
  verifyEmailSuccess
} from './user.actions';
import { createReducer, on } from '@ngrx/store';
import { initialUserState } from './user.state';

export const reducer = createReducer(
  initialUserState,

  /*
   * ANALYTICS.22 -- EVERY action that sets `loading: true` now has a failure
   * handler that clears it.
   *
   * There were none. `getUsers` set loading true, `getUsersSuccess` cleared it,
   * and `getUsersFailure` was not even imported -- so a failed load left
   * `loading` true forever. That was invisible while nothing read the flag: the
   * table simply stayed empty and a refresh usually fixed it.
   *
   * It stopped being invisible the moment Account Manager grew a spinner. One
   * failed query -- and against a remote database a connection timeout is a
   * real possibility -- meant a spinner that never stopped, no data, and no
   * error: "spinner, no data, nothing happens ever".
   *
   * A reducer that can enter a state it cannot leave is the bug. The spinner
   * only made it visible.
   */
  on(getUsers, (state) => ({
    ...state,
    loading: true,
    loadFailed: false
  })),
  on(getUsersSuccess, (state, { users }) => ({
    ...state,
    users: users,
    loading: false,
    loadFailed: false
  })),
  on(getUsersFailure, (state) => ({
    ...state,
    loading: false,
    loadFailed: true
  })),
  on(getEmailToVerify, (state, { token }) => ({
    ...state,
    verifiedEmail: null,
    verificationToken: token
  })),
  on(getEmailToVerifySuccess, (state, { email }) => ({
    ...state,
    verifiedEmail: email
  })),
  on(saveUser, (state) => ({
    ...state,
    loading: true
  })),
  on(saveUserFailure, (state) => ({
    ...state,
    loading: false
  })),
  on(saveUserSuccess, (state, { profile }) => ({
    ...state,
    loading: false,
    users: state.users.map((user) => {
      if (user.userId === profile.userId) {
        return {
          ...user,
          firstName: profile.firstName,
          lastName: profile.lastName
        };
      }
      return user;
    })
  })),
  on(inviteUsers, (state) => ({
    ...state,
    loading: true
  })),
  on(inviteUsersFailure, (state) => ({
    ...state,
    loading: false
  })),
  on(inviteUsersSuccess, (state) => ({
    ...state,
    loading: false
  })),
  on(verifyEmail, (state) => ({
    ...state,
    loading: true
  })),
  on(verifyEmailFailure, (state) => ({
    ...state,
    loading: false
  })),
  on(verifyEmailSuccess, (state, { success, verifiedEmail }) => ({
    ...state,
    loading: false,
    verifiedEmail: success ? verifiedEmail : null
  })),
  on(createAccount, (state) => ({
    ...state,
    loading: true
  })),
  on(createAccountSuccess, (state, { user }) => ({
    ...state,
    loading: false
  })),
  on(resetPassword, (state) => ({
    ...state,
    loading: true
  })),
  on(resetPasswordSuccess, (state) => ({
    ...state,
    loading: false
  }))
);
